import { FulfillmentType } from "./graphql-client/generated";
import type { OrderDispatchOption } from "./types";

// Known combined height of Jet's header and category bar
export const PAGE_TOPSET = 163;

// Note: If you change the max width consider changing the base size of the product menu images
// Currently images are 540 wide (a bit wider than maxWidth / 3)
export const PAGE_MAX_WIDTH = 1500;

// Viewports - matching Box component responsive system
export const VIEWPORT_MD = 740;
export const VIEWPORT_LG = 992;

export const HOT_DEALS_CATEGORY_ID_PREFIX = "hotdeals";

export const LATEST_ORDER_COOKIE_NAME_PREFIX = "latestOrder-";

export const AUTH_CODE_NONCE_COOKIE_KEY = "authCodeNonce";

// App platform detection
export const APP_PLATFORM_COOKIE_NAME = "app-platform";
export const APP_PLATFORM = {
  IOS: "LOKE iOS App",
  ANDROID: "LOKE Android App",
  WEB: "LOKE Web App",
} as const;
export const APP_PLATFORM_COOKIE_OPTIONS = {
  path: "/",
  maxAge: 60 * 60 * 24 * 365, // 1 year
  sameSite: "lax" as const,
};

// for stripe API
export const STRIPE_API_VERSION = "2023-10-16";
export const STRIPE_OPTIONS = {
  fonts: [
    {
      cssSrc:
        "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700",
    },
  ],
};

export const OrderDispatchOptionToFulfillmentType: Record<
  OrderDispatchOption,
  FulfillmentType
> = {
  DELIVERY: FulfillmentType.Delivery,
  PICK_UP: FulfillmentType.PickUp,
  SERVICE: FulfillmentType.Service,
};
